import Vue from 'vue'
import Router from 'vue-router'
import IndexPage from '@/pages/IndexPage'
import PartnerInstitutions from '@/pages/partner_institutions/index'
import Specialist from '@/pages/specialist/index'
import CareerPanorama from '@/pages/career_panorama/index'
import CareerPlanning from '@/pages/career_planning/index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'IndexPage',
      component: IndexPage
    },
    {
      path: '/PartnerInstitutions',
      name: 'PartnerInstitutions',
      component: PartnerInstitutions
    },
    {
      path: '/Specialist',
      name: 'Specialist',
      component: Specialist
    },
    {
      path: '/CareerPanorama',
      name: 'CareerPanorama',
      component: CareerPanorama
    },
    {
      path: '/CareerPlanning',
      name: 'CareerPlanning',
      component: CareerPlanning
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js